import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const TextStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  cursor: default;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
  display: inline;

  /* Child element styles
  ------------------------------- */
  #tootip-his-app {
    margin-top: 1em;
  }
  .__react_component_tooltip {
    padding: 5px 10px;
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};

    &.show {
      opacity: 1;
    }

    &.background-white {
      background-color: white;
      box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.12) !important;
      border: 0 !important;
      color: ${VARIABLES.COLORS.GRAY_3};
      white-space: pre-line;

      &.place-bottom {
        border-bottom-color: white;

        &:after,
        &before {
          display: none;
        }
      }

      &.place-top {
        border-top-color: white;

        &:after,
        &before {
          display: none;
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */
  .ellipsis-items {
    display: table;
    table-layout: fixed;
    width: 100%;
  }

  .ellipsis-item {
    /* flex: 1; */
    display: table-cell;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.color-green {
    color: ${VARIABLES.COLORS.GREEN_1};
  }

  &.has-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: auto;
    font-weight: 600;
  }
  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    .__react_component_tooltip {
      padding: 5px 9px;
      font-size: 16px;
    }
  }

  @media all and (max-width: 1440.98px) {
    .__react_component_tooltip {
      padding: 4px 8px;
      font-size: 15px;
    }
  }

  @media all and (max-width: 1366.98px) {
    .__react_component_tooltip {
      padding: 4px 7px;
      font-size: 14px;
    }
  }

  @media all and (max-width: 1280.98px) {
    .__react_component_tooltip {
      padding: 3px 6px;
      font-size: 13px;
    }
  }

  @media all and (max-width: 1024.98px) {
    .__react_component_tooltip {
      padding: 3px 5px;
      font-size: 12px;
    }
  }
`
